<template>
  <base-layout>
  <template v-slot:header>
    <app-header/>
  </template>
  <template v-slot:default>
   <BulkDisplay/>
  </template>

  <template v-slot:footer>
   <app-footer/>
  </template>
</base-layout>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppFooter from '@/components/AppFooter'
import BulkDisplay from '@/components/BulkDisplay'
import BaseLayout from '@/layout/BaseLayout'

export default {
  components: {
    BaseLayout,
    AppHeader,
    BulkDisplay,
    AppFooter
  },
  mounted () {
    window.analytics.page('Bulk Buy')
  },
  metaInfo () {
    return {
      title: 'SanitizerWristbands.com: Buy Bulk and Resell - 50% discount or more on all orders above 100 pieces'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/BulkBuy.vue